import { Component, Input } from '@angular/core';
import { AVAILABLE_PERMISSIONS } from '@app/constants';
import {
  UserProfile,
  PermissionChangeTypeEnum,
} from '@app/admin/user/model/user-history.model';
import { HistoryPermissionRow } from '@app/shared/models/history.model';
import { PERMISSIONS_HEADER_CONFIG } from '@app/shared/permissions/permissions-header.config';

@Component({
  selector: 'flow-permissions-history-table',
  templateUrl: './permissions-history-table.component.html',
  styleUrls: ['./permissions-history-table.component.scss'],
})
export class PermissionsHistoryTableComponent {
  @Input() userProfiles: UserProfile[] = [];

  headerConfig = PERMISSIONS_HEADER_CONFIG.map(header => ({
    ...header,
    colSpan: header.actions.reduce(
      (sum, action) => sum + action.permissions.length,
      0
    ),
  }));

  availablePermissions = AVAILABLE_PERMISSIONS.slice(1);

  PermissionChangeTypeEnum = PermissionChangeTypeEnum;

  get permissionRows(): HistoryPermissionRow[] {
    const rows: HistoryPermissionRow[] = [];
    for (const profile of this.userProfiles) {
      if (profile.customerName != null && profile.customerPermissions?.length) {
        rows.push({
          label: profile.customerName,
          permissions: profile.customerPermissions,
        });
      }
      if (profile.groupName != null && profile.groupPermissions?.length) {
        rows.push({
          label: `${profile.customerName} (${profile.groupName})`,
          permissions: profile.groupPermissions,
          groupAction: profile.groupAction
        });
      }
    }
    return rows;
  }
}
